import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import ConsensoInformato from '@/components/ConsensoInformato';
import { Badge } from '@/components/ui/badge';
import { FileText, Shield, Download } from 'lucide-react';

const ConsensoInformatoPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      <Navigation />
      
      {/* Hero Section */}
      <section className="section-padding bg-gradient-to-r from-primary to-primary-dark text-white">
        <div className="container-custom text-center space-y-6">
          <Badge className="bg-white/20 text-white border-white/30">
            Documentazione Sanitaria
          </Badge>
          <h1 className="text-4xl lg:text-5xl font-bold">
            Consenso Informato
          </h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Genera e scarica il modulo di consenso informato per il trattamento fisioterapico. 
            Documento aggiornato secondo le normative vigenti.
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <div className="flex items-center space-x-2">
              <Shield className="h-4 w-4" />
              <span>Conforme GDPR</span>
            </div>
            <div className="flex items-center space-x-2">
              <FileText className="h-4 w-4" />
              <span>Aggiornato 2024</span>
            </div>
            <div className="flex items-center space-x-2">
              <Download className="h-4 w-4" />
              <span>Scaricabile PDF</span>
            </div>
          </div>
        </div>
      </section>

      {/* Modulo Consenso */}
      <section className="section-padding">
        <div className="container-custom">
          <ConsensoInformato />
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ConsensoInformatoPage;